import styled from 'styled-components';

export const StepThreeStyled = styled.div`
  display: flex;
  justify-content: center;
  
  .feesBySolutionStepThree {
    &__variables {
      flex: 1;
      padding-right: 5px;
    }
    
    &__invoice {
      padding-left: 5px;
    }
  }

  & .boxBody__container {
    background-color: transparent;
  }
  
  & .variableSelector__items {
    background-color: ${props => props.theme.uiColors.feesBySolutionBackground01};
    border-radius: 4px;
  }

  & .levelContent__title {
    margin-left: 16px;
    color: ${props => props.theme.uiColors.feesBySolutionCapabilityCategoryTitle};
    text-transform: uppercase;
    font-family: ${props => props.theme.fontSemiBold};
    
    &:first-child {
      margin-top: 16px;
    }
  }
  
  & .variableSelector__filtersBottom-buttonContainer {
    display: flex;
    width: 132px;
    justify-content: end;
  }
  
  & .variableSelector__filters {
    display: contents;
  }
`;
